<template>
<bernstein-layout>
        <Head title="Addison Export " />
    <div class ="flex flex-wrap justify-center w-full "> 
        <order-create class="w-auto" :downloadIcon="downloadIcon" > </order-create>
        <div class="flex flex-col  justify-center items-center px-2 w-1/2">
                <p class="px-2 py-4 text-gray-800 text-xl font-bold"> 
                    Addison Export </p>
    
            <div  v-if="isLink" class=" flex flex-col items-center "> 
                <p class="mb-6"> If the export has not been downloaded automatically, 
                    you can click here again to download the export data. </p> 
                <p>     <a class=" px-4 py-4 bg-gray-700 border rounded-lg text-white  font-semibold" 
                            :href="$page.props.flash.message"> DOWNLOAD HERE 
                            </a>
                </p>
                    
            </div>
            <div v-if="form.processing" class="flex flex-wrap items-center space-x-3">
                <p class="text-red-600 py-2 font-bold" > 
                        Export  Vorbereitung läuft 
                </p>
                <div class="p-2 my-2"> 
                <!-- {{downloadIcon}}  -->
                <!-- <img :src="downloadIcon" />  -->
                    <img :src="downloadIcon" 
                    alt="HTML5 Icon" width="250" height="250">
                </div> 
            </div>
            <form @submit.prevent="submit" 
            class="flex flex-col justify-center w-full max-w-md">
                <div class="mb-2 py-2"> 
                <label for="start_date"> Startdatum </label>

                <jet-input 
                    id="start_date" 
                    type="date" 
                    class="mt-1 block w-full" 
                    v-model="form.start_date" 
                    required autofocus />
                </div>
                <div class="mb-2 py-2"> 
                <label for="end_date" > Enddatum </label>
                <jet-input 
                    id="end_date" 
                    type="date" 
                    class="mt-1 block w-full" 
                    v-model="form.end_date" 
                    autofocus /> </div>
                <div class="mb-2 py-2"> 
                <!-- <button type="submit"> Addison Export </button> -->
                
                    <jet-button class=" w-full text-center  " 
                    :class="{ 'opacity-25 ': form.processing }" 
                    :disabled="form.processing">
                    <span class=" m-auto text-center py-2">  Addison Export</span>
                    </jet-button>
                </div> 
            </form>
            
        </div>
    </div>
</bernstein-layout>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import BernsteinLayout from '@/Layouts/BernsteinLayout.vue'
import OrderCreate from '@/Pages/Orders/Create.vue'
import JetButton from '@/Jetstream/Button.vue'
import JetInput from '@/Jetstream/Input.vue'

export default {
    props:{
        message: String,
        appName:String,
        downloadIcon: String
        
    },
    components:{
        Head,
        Link,
        BernsteinLayout,
        JetButton,
        JetInput,
        OrderCreate
    },
    data(){
        return {
           form: this.$inertia.form({
                    _method: 'PUT',
                     start_date: null,
                     end_date: null,
                   processing: false
                }),
                isLink:false,
        }
    },
 
  methods:{
      submit (){
          this.form.processing=true;
          this.form.post(route('orders.addison-export-submit'), {
                    // errorBag: 'updateProfileInformation',
                    preserveScroll: true,
                    resetOnSuccess: false,
                     onSuccess: (response) => (this.downloadExport(response)), 
                   
                },
                {
                    
                });
      },
      downloadExport(response){
        //   alert("test");
        // console.log(response.props.flash.message);
        this.form.processing =false;
        this.isLink =true;
        var link     = response.props.flash.message;
        var element  = document.createElement('a');
        element.setAttribute('href', link);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
  
      }
  }
  
}
</script>
